
import Vue from "vue";
import { NewCompaniesApiFunc } from "@/api";
import { setAccessToken } from "@/api";
import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import IosSafariOverlap from "@/layout/ios-safari-overlap.vue";
import mobile from "@/utils/mobile";
import { ValidationProvider } from "vee-validate";
import dayjs from "dayjs";
const DEADLINE = "2023-02-28 23:59:59";

export type DataType = {
  loginId?: string;
  password?: string;
  whileTryingLogin: boolean;
};

export default Vue.extend({
  name: "LoginScreen",

  components: {
    BaseInputForm,
    BaseSubmitButton,
    ValidationProvider,
    IosSafariOverlap,
  },

  data(): DataType {
    return {
      loginId: undefined,
      password: undefined,
      whileTryingLogin: false,
    };
  },

  async mounted() {
    this.$auth.restore();
    if (this.$auth.isAuthed()) {
      await this.getCompany();
      this.$router.push("/");
    }
  },

  computed: {
    isPC(): boolean {
      return mobile.isPC();
    },
    canSubmit(): boolean {
      return !!this.loginId && !!this.password;
    },
    passwordForgotLinkClassText(): string {
      return this.whileTryingLogin ? "disabled" : "";
    },
    isBeforeDeadline(): boolean {
      const now = dayjs().unix();
      const deadline = dayjs(DEADLINE).unix();
      return now <= deadline;
    },
  },

  methods: {
    async tryLogin(): Promise<void> {
      if (!this.canSubmit) {
        return;
      }

      this.$setLoading(true);
      this.whileTryingLogin = true;

      const err = await Vue.prototype.$auth.login(this.loginId, this.password);
      if (err) {
        this.$setLoading(false);
        this.whileTryingLogin = false;
        this.$handleApiError(err, this.tryLogin);
        return;
      }

      setAccessToken(this.$auth.accessToken);

      this.$setLoading(false);
      this.whileTryingLogin = false;
      this.$setChecked(true);

      this.$afterSuccessRequest(() => {
        if (this.$auth.companyId) {
          this.getCompany();
        }

        this.$router.push({ path: "/" });
      }, 2);
    },

    async getCompany(): Promise<void> {
      const companyId = this.$auth.companyId as string;
      const res = await NewCompaniesApiFunc().getCompany(companyId);

      if (res.err != null) {
        this.$handleApiError(res.err, this.getCompany);
        return;
      }
      this.$globalData.setCompany(res.data);
    },

    afterLeave(): any {
      this.$setChecked(false);
    },
  },
});
